// Lib
import React from 'react';

// Components
import { ReactComponent as Sorter } from '../../../assets/svg/sorter.svg';
import { ReactComponent as TabletSorter } from '../../../assets/svg/tabletSorter.svg';

// Hooks
import useUser from '../../../hooks/useUser';
import useUI from '../../../hooks/useUI';

// Styles
import { useStyles } from './SortButtonStyles';

const SortButton = ({ order = 'asc', onClick }) => {
  const { isKiteUser } = useUser();
  const { isMobileMode, isTabletMode } = useUI();

  const SorterComponent = !isMobileMode && isTabletMode ? TabletSorter : Sorter;

  const { classes } = useStyles({ order, isKiteUser });

  return (
    <SorterComponent
      onClick={onClick}
      className={classes.root}
      data-testid={'sort-button'}
    />
  );
};

export default SortButton;
